/**
 *
 * EditService
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import { DAEMON } from 'utils/constants';
import reducer from './reducer';
import saga from './saga';
import withEdit from './withEdit';

function EditService({ children, ...props }) {
  return React.Children.map(children, child =>
    React.cloneElement(child, props),
  );
}

EditService.propTypes = {
  children: PropTypes.node.isRequired,
};

const withReducer = injectReducer({ key: 'editservice', reducer });
const withSaga = injectSaga({ key: 'editservice', saga, mode: DAEMON });

export default compose(
  withReducer,
  withSaga,
  withEdit,
)(EditService);
